import { format } from 'date-fns';

import { ClockIcon } from '@/ui/Icons/ClockIcon';
import {
  MatchaTooltip,
  MatchaTooltipBottomSheet,
  MatchaTooltipContent,
  MatchaTooltipPopover,
  MatchaTooltipTrigger,
} from '@/ui/MatchaTooltip';

import { formatTimeElapsed } from '@/utils/numbers';

type TokenAgeBadgeProps = {
  /** Token creation time, in seconds. */
  creationTime: number;
};

export const TokenAgeBadge = ({ creationTime }: TokenAgeBadgeProps) => (
  <MatchaTooltip>
    <MatchaTooltipTrigger>
      <button type="button" className="flex flex-row items-center gap-1 cursor-default">
        <ClockIcon className="text-token-gray-700" />
        {formatTimeElapsed(creationTime, true)}
      </button>
    </MatchaTooltipTrigger>
    <MatchaTooltipContent>{format(new Date(creationTime * 1000), 'Pp')}</MatchaTooltipContent>
    <MatchaTooltipPopover sideOffset={8} />
    <MatchaTooltipBottomSheet header="Token creation time" />
  </MatchaTooltip>
);
